import { getData } from './http';

const url = '/api2/destination/maps/google';

export function getStaticMapUrl(mapUrl) {
    return getData(`${url}/signstaticmapurl?url=${encodeURIComponent(mapUrl)}`,
        { cache: true, logErrors: false });
}
